<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onRefresh()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <!-- specifications -->
        <section class="tw-w-full">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-chart-box-outline tw-ml-2 mdi-24px"></i>
              <span>
                {{
                  pageVocabs + "legends.competitionSpecifications" | translate
                }}</span
              >
            </legend>

            <div class="row">
              <!-- title -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  class="tw-w-full"
                  [(value)]="model.title"
                  [control]="form?.get('title')"
                  label="common.title"
                >
                </form-field>
              </div>

              <!-- privateNumberId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <private-number-select-search
                  [label]="fields + 'privateNumberId' | translate"
                  [control]="form?.get('privateNumberId')"
                  [value]="model.privateNumberId"
                  [sendType]="SendTypes.Single"
                  (itemChange)="onSelectPrivateNumber($event)"
                >
                </private-number-select-search>
              </div>

              <!-- senderPhonebookId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <phonebook-select-search
                  type="phonebooksListForServices"
                  [label]="fields + 'senderPhonebookId' | translate"
                  [control]="form?.get('senderPhonebookId')"
                  [(value)]="model.senderPhonebookId"
                >
                </phonebook-select-search>
              </div>

              <!-- isSendActive -->
              <div
                class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
              >
                <mat-slide-toggle
                  formControlName="isActive"
                  [(ngModel)]="model.isActive"
                >
                  {{ "common.isActive" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- start date time picker -->
              <app-periodic-date-time-picker
                class="tw-w-full"
                [config]="periodicDateTimeConfig"
                (startDateTime)="model.startDateTime = $event"
                (endDateTime)="model.endDateTime = $event"
              >
              </app-periodic-date-time-picker>
            </div>
          </fieldset>
        </section>

        <!-- responses -->
        <section class="md:tw-w-full xl:tw-w-1/2 tw-mt-4">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-message-badge-outline tw-ml-2 mdi-24px"></i>
              <span>
                {{
                  pageVocabs + "legends.competitionResponse" | translate
                }}</span
              >
            </legend>

            <div class="row">
              <ng-container
                *ngFor="let item of model.responses; let index = index"
              >
                <div class="md:tw-w-1/2">
                  <h3 class="tw-mt-2 tw-mb-5">
                    {{
                      item?.type | enumToText : PollParserResponseTypeEnumValues
                    }}
                  </h3>

                  <app-sms-body
                    [isEditMode]="formPageConfig.isEditMode"
                    [form]="responsesForm"
                    [smsBodyControlName]="'text' + index"
                    [senderNumberControlName]="'privateNumber' + index"
                    [isAddSignature]="false"
                    [isAddHeader]="false"
                    [isShowSmsTemplate]="false"
                    [senderNumberId]="model.responses[index].privateNumber?.id"
                    [smsBody]="responses[index]?.text"
                    [sendType]="SendTypes.Single"
                    (finalSmsBody)="onSetResponseText($event, index)"
                    (senderNumber)="onSetResponsePrivateNumber($event, index)"
                  >
                  </app-sms-body>
                </div>
              </ng-container>
            </div>
          </fieldset>
        </section>

        <!-- formulas -->
        <section class="md:tw-w-full xl:tw-w-1/2 tw-mt-4">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-format-list-bulleted tw-ml-2 mdi-24px"></i>
              <span>
                {{
                  pageVocabs + "legends.competitionMatchOptions" | translate
                }}</span
              >
            </legend>

            <form [formGroup]="formulasForm">
              <div class="row">
                <!-- optionTitle -->
                <div class="xl:tw-w-1/2">
                  <form-field
                    class="tw-w-full"
                    [(value)]="optionTitle"
                    [control]="form?.get('optionTitle')"
                    [label]="fields + 'optionTitle' | translate"
                  >
                  </form-field>
                </div>

                <!-- keyword -->
                <div class="xl:tw-w-1/2">
                  <form-field
                    class="tw-w-full"
                    [(value)]="keyword"
                    [control]="form?.get('keyword')"
                    [label]="fields + 'keyword' | translate"
                  >
                  </form-field>
                </div>

                <!-- phonebookId -->
                <div class="xl:tw-w-1/2">
                  <phonebook-select-search
                    controlName="phonebookId"
                    [label]="fields + 'phonebookName' | translate"
                    type="phonebooksListForServices"
                    [value]="selectedPhonebookId"
                    [control]="formulasForm?.get('phonebookId')"
                    (itemChange)="onChangeSelectPhonebook($event)"
                  >
                  </phonebook-select-search>
                </div>

                <!-- isCorrect -->
                <div
                  class="sm:tw-w-1/6 md:tw-w-1/3 xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
                >
                  <mat-slide-toggle
                    formControlName="isCorrect"
                    [(ngModel)]="isCorrect"
                  >
                    {{ fields + "isCorrect" | translate }}
                  </mat-slide-toggle>
                </div>

                <!-- add btn -->
                <div
                  class="sm:tw-w-1/4 md:tw-w-5/12 xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
                >
                  <a
                    class="btn"
                    [themeColor]="'btn-info'"
                    (click)="onAddOption()"
                  >
                    <i
                      class="mdi mdi-plus-circle-outline mdi-18px tw-text-white"
                    ></i>
                    {{ "common.add" | translate }}
                  </a>
                </div>

                <div
                  class="md:tw-w-full tw-mb-2 formulas-table tw-border dark:tw-border-dark-100 !tw-p-0 tw-mt-4 tw-relative table-responsive"
                >
                  <table
                    class="table table-striped-even table-head-custom table-vertical-center overflow-hidden !tw-mb-0"
                  >
                    <thead class="dark:tw-border-b-dark-100 tw-border-b">
                      <tr
                        class="fw-bold fs-6 tw-text-gray-800 dark:tw-text-gray-300"
                      >
                        <th>
                          {{ fields + "optionTitle" | translate }}
                        </th>
                        <th>
                          {{ fields + "keyword" | translate }}
                        </th>
                        <th>
                          {{ fields + "phonebookName" | translate }}
                        </th>
                        <th>
                          {{ fields + "isCorrect" | translate }}
                        </th>
                        <th>
                          <!-- {{ 'common.detail' | translate}} -->
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let item of model.formulas; let index = index"
                      >
                        <td>{{ item.title }}</td>
                        <td class="font-vazir-ui">{{ item.keyword }}</td>
                        <td>{{ item.phonebookName }}</td>
                        <td>
                          <span>
                            <i
                              class="mdi mdi-check-bold text-success mdi-16px"
                              *ngIf="item.isCorrect"
                            ></i>
                            <i
                              class="mdi mdi-close-thick text-danger mdi-16px"
                              *ngIf="!item.isCorrect"
                            ></i>
                          </span>
                        </td>
                        <td>
                          <a
                            (click)="onRemoveOption(index)"
                            class="tw-cursor-pointer tw-pl-2"
                            [matTooltip]="'common.delete' | translate"
                          >
                            <i
                              class="mdi mdi-trash-can-outline mdi-20px text-danger"
                            ></i>
                          </a>
                        </td>
                      </tr>
                      <tr
                        *ngIf="model.formulas?.length === 0"
                        class="tw-text-center tw-text-gray-600"
                      >
                        <td
                          colspan="4"
                          class="tw-text-center tw-text-gray-600 tw-pb-5 tw-pt-[25px]"
                        >
                          {{ pageVocabs + "messages.emptyOption" | translate }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </form>
          </fieldset>
        </section>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
